var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"emoji-container"},[_c('VEmojiPicker',{directives:[{name:"click-outside",rawName:"v-click-outside",value:(_vm.closeEmojiPopup),expression:"closeEmojiPopup"}],staticClass:"emoji-picker",style:({'--border-colour': _vm.spaceBackgroundColour}),attrs:{"dark":true},on:{"select":_vm.selectEmoji}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }